import { format, parseISO } from "date-fns";
import { useEffect } from "react";
import { BACKEND_URL } from "./api";

export const formatPrice = (value) =>
  value == null ? "-" : `$${Number(value).toLocaleString("en-NZ", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export const formatDate = (d, pattern = "EEE, d MMM yyyy") => (d ? format(parseISO(d), pattern) : "");

export const formatTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const suffix = h >= 12 ? "pm" : "am";
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${suffix}`;
};

export const formatDuration = (mins) => {
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m ? `${h} hr ${m} min` : `${h} hour${h > 1 ? "s" : ""}`;
};

export const imageUrl = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const DAYS = [
  ["mon", "Monday"], ["tue", "Tuesday"], ["wed", "Wednesday"], ["thu", "Thursday"],
  ["fri", "Friday"], ["sat", "Saturday"], ["sun", "Sunday"],
];

export const SERVICE_TYPES = ["At your place", "At business location", "Online"];

export const NZ_CITIES = ["Auckland", "Wellington", "Christchurch", "Hamilton", "Tauranga", "Dunedin"];

export function useTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | Bookvera` : "Bookvera | Discover. Compare. Book.";
  }, [title]);
}
